"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var main_1 = tslib_1.__importDefault(require("./main"));
var mini_1 = tslib_1.__importDefault(require("./mini"));
exports.default = {
    main: main_1.default,
    mini: mini_1.default,
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/geoms/area/index.js
// module id = 857
// module chunks = 37